<template>
  <div>
    <div class="container-loading" v-if="loading" :style="`min-height: ${height}px`">
      <app-loader></app-loader>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import AppLoader from "@/components/app-loader";
export default {
  name: "loading-container",
  components: { AppLoader },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: '600'
    }
  },
  watch:{
    loading(n){
      if(!n){
        setTimeout(()=>{
          this.$emit('loaded')
        },500)
      }
    }
  }
}
</script>

<style scoped>
.container-loading{
  width: 100%;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>